// FILE: src/data/seed.js
// Updated with functional Unsplash URLs for the gallery.

export const initialRestaurants = [
    {
        name: "The Sefton",
        cuisine: "British",
        address: "3 Ormskirk St, St Helens, WA10 2RS",
        rating: 4.5,
        priceRange: "££",
        latitude: 53.4543,
        longitude: -2.7331,
        imageUrl: "https://source.unsplash.com/1200x600/?british,food",
        gallery: [
            "https://source.unsplash.com/600x400/?pub,interior",
            "https://source.unsplash.com/600x400/?steak,ale,pie",
            "https://source.unsplash.com/600x400/?english,pub",
        ],
        ownerId: "",
        vouchers: [
            { id: 'v1', description: "2 for 1 on Main Courses", details: "Valid Mon-Thu, 12-5pm." },
            { id: 'v2', description: "Free Bottle of House Wine", details: "When two adults order a main course." },
            { id: 'v3', description: "Kids Eat Free", details: "With a paying adult. Max 2 children." },
            { id: 'v4', description: "20% Off Sunday Roast", details: "Valid for tables of 4 or more." },
            { id: 'v5', description: "Complimentary Dessert", details: "With any starter and main." },
        ],
        menu: {
            starters: [ { name: "Soup of the Day", price: "£5.50" }, { name: "Prawn Cocktail", price: "£7.50" } ],
            mains: [ { name: "Fish and Chips", price: "£14.00" }, { name: "8oz Sirloin Steak", price: "£22.00" } ],
            desserts: [ { name: "Sticky Toffee Pudding", price: "£6.00" } ]
        }
    },
    {
        name: "Pied Bull",
        cuisine: "Pub Food",
        address: "54 High St, Newton-le-Willows, WA12 9SH",
        rating: 4.6,
        priceRange: "££",
        latitude: 53.4515,
        longitude: -2.6288,
        imageUrl: "https://source.unsplash.com/1200x600/?pub,food",
        gallery: [
            "https://source.unsplash.com/600x400/?pub,garden",
            "https://source.unsplash.com/600x400/?gourmet,burger",
            "https://source.unsplash.com/600x400/?craft,beer,bar",
        ],
        ownerId: "",
        vouchers: [
            { id: 'v6', description: "Burger and a Pint for £15", details: "Available all day Monday." },
            { id: 'v7', description: "15% Off Total Food Bill", details: "Not valid on Saturdays." },
            { id: 'v8', description: "Two Cocktails for £12", details: "Valid 5pm-7pm on Fridays." },
            { id: 'v9', description: "Free Starter with any Grill Item", details: "Excludes sharing platters." },
            { id: 'v10', description: "£5 Off When You Spend £30", details: "On food only." },
        ],
        menu: {
            starters: [ { name: "Chicken Wings", price: "£6.95" }, { name: "Halloumi Fries", price: "£6.50" } ],
            mains: [ { name: "Scampi & Chips", price: "£13.50" }, { name: "Sausage & Mash", price: "£12.95" } ],
            desserts: [ { name: "Chocolate Fudge Cake", price: "£6.25" } ]
        }
    },
    {
        name: "La Casa Vieja",
        cuisine: "Spanish",
        address: "6-12 Library St, St Helens, WA10 1DH",
        rating: 4.7,
        priceRange: "£££",
        latitude: 53.4539,
        longitude: -2.7369,
        imageUrl: "https://source.unsplash.com/1200x600/?tapas,food",
        gallery: [
            "https://source.unsplash.com/600x400/?spanish,restaurant",
            "https://source.unsplash.com/600x400/?paella",
            "https://source.unsplash.com/600x400/?sangria",
        ],
        ownerId: "",
        vouchers: [
            { id: 'v11', description: "3 Tapas Plates for £18", details: "Available all day, every day." },
            { id: 'v12', description: "Free Sangria Jug", details: "For tables of 4 or more." },
            { id: 'v13', description: "25% Off Midweek Dining", details: "Valid Tuesday to Thursday." },
            { id: 'v14', description: "Paella for Two for £25", details: "Pre-booking required." },
            { id: 'v15', description: "Free Churros with any Main", details: "One portion per table." },
        ],
        menu: {
            starters: [ { name: "Patatas Bravas", price: "£5.00" }, { name: "Gambas al Ajillo", price: "£8.00" } ],
            mains: [ { name: "Seafood Paella", price: "£16.00" }, { name: "Chorizo al Vino", price: "£7.50" } ],
            desserts: [ { name: "Churros con Chocolate", price: "£6.50" } ]
        }
    },
    {
        name: "Anatolia Grill",
        cuisine: "Turkish",
        address: "55 Duke St, St Helens, WA10 2JF",
        rating: 4.8,
        priceRange: "££",
        latitude: 53.4518,
        longitude: -2.7352,
        imageUrl: "https://source.unsplash.com/1200x600/?turkish,kebab",
        gallery: [
            "https://source.unsplash.com/600x400/?turkish,restaurant,interior",
            "https://source.unsplash.com/600x400/?mixed,grill",
            "https://source.unsplash.com/600x400/?baklava",
        ],
        ownerId: "",
        vouchers: [
            { id: 'v16', description: "Mixed Grill Sharer for £30", details: "Serves two people." },
            { id: 'v17', description: "20% Off Lunch Menu", details: "Valid 12pm-4pm weekdays." },
            { id: 'v18', description: "Free Turkish Tea & Baklava", details: "With any main course." },
            { id: 'v19', description: "Set Menu: 2 Courses for £19.95", details: "Available Sunday to Thursday." },
            { id: 'v20', description: "10% Off Takeaway Orders", details: "On orders over £25." },
        ],
        menu: {
            starters: [ { name: "Hummus & Pitta", price: "£4.50" }, { name: "Sigara Boregi", price: "£5.50" } ],
            mains: [ { name: "Adana Kebab", price: "£15.00" }, { name: "Lamb Shish", price: "£16.50" } ],
            desserts: [ { name: "Kadayif", price: "£6.00" } ]
        }
    },
    {
        name: "The Park Bar & Kitchen",
        cuisine: "Pub Food",
        address: "Sherdley Rd, St Helens, WA9 5DE",
        rating: 4.3,
        priceRange: "££",
        latitude: 53.435,
        longitude: -2.733,
        imageUrl: "https://source.unsplash.com/1200x600/?gastropub",
        gallery: [
            "https://source.unsplash.com/600x400/?golf,course,restaurant",
            "https://source.unsplash.com/600x400/?afternoon,tea",
            "https://source.unsplash.com/600x400/?sunday,roast",
        ],
        ownerId: "",
        vouchers: [
            { id: 'v21', description: "Afternoon Tea for Two for £25", details: "Booking essential." },
            { id: 'v22', description: "Steak Night: Two for £35", details: "Every Thursday from 5pm." },
            { id: 'v23', description: "Free Coffee with any Cake", details: "Valid 10am-12pm." },
            { id: 'v24', description: "10% Off for Golf Club Members", details: "Show membership card." },
            { id: 'v25', description: "Pie and a Pint for £14", details: "Every Wednesday." },
        ],
        menu: {
            starters: [ { name: "Black Pudding Fritters", price: "£6.75" }, { name: "Creamy Garlic Mushrooms", price: "£6.25" } ],
            mains: [ { name: "Gammon Steak", price: "£14.50" }, { name: "Chicken & Leek Pie", price: "£13.95" } ],
            desserts: [ { name: "Apple Crumble", price: "£6.00" } ]
        }
    }
];
